<template>
    <div>
    <!-- <form @submit.prevent="login">
    <label>Email</label>
    <input type="email" v-model="email" required>
    <label>Password</label>
    <input type="password" v-model="password" required>
    <button type="submit">Login</button>
    <button @click="handleClick">Click me!</button>

    </form> -->
    Redirecting...
    </div>
</template>
    
    <script>
    import {API_AUTH_URL} from '../constants/index';

    export default {
      async mounted() {
        try {
          // const params = new URLSearchParams(window.location.search);
          const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json'},
              // body: JSON.stringify(params),
              // mode: 'no-cors'
          };
          const url = `${API_AUTH_URL}/v1/external/login`;
    
          const queryParams = new URLSearchParams(window.location.search);
          const finalUrl = url + '?' + queryParams.toString();
          await fetch(finalUrl, requestOptions)
                .then(res=>res.json())
                .then(data => {
                    this.$emit('loginResponse', data)
                }).catch(error => console.log(error));
                    // Handle successful login
            } catch (error) {
              console.log(error);
            }
      }
    };
    </script>
    